import referenceCheckV2API from 'api/referenceCheckV2API';
import { Reference } from 'types';
import { ReferenceToSubmit } from '../../AddContact/types';

export const createHiringRequestReference = (
  payload: ReferenceToSubmit | FormData
): Promise<Reference> => {
  return referenceCheckV2API.create(payload).then((res) => res);
};
